import { Schemas } from '~/api/gen'
import { Chip } from '~/components/elements/Chip'
import { buildUrl } from '~/features/shared/search/coordinate/builder/buildUrl'
import { Base } from './Base'

type Props = {
  brands: Schemas.coordinate_item_response[]
}

const buildUrlAndName = (
  brand: Schemas.item_resource_connect['brand'],
  category: Schemas.item_category_small,
  childCategory: Schemas.item_child_category
): { url: string; name: string } | undefined => {
  if (!category) return undefined
  if (!brand.name || !brand.id || !brand.key) return undefined

  const url = buildUrl({
    snapItems: [
      {
        brand: { id: brand.id, key: brand.key, name: brand.name },
        category: {
          name: category.name,
          key: category.keyword,
          id: category.id,
          child: childCategory?.keyword
            ? {
                name: childCategory.name,
                key: childCategory.keyword,
                id: childCategory.id,
              }
            : undefined,
        },
      },
    ],
  })
  const name = `${brand.name} × ${childCategory?.name ?? category.name}`
  return { url, name }
}

export const SimilarItemCoordinate: React.FC<Props> = ({ brands }) => {
  return (
    <Base title="似ているアイテム">
      {brands.map(({ id, item }) => {
        const urlAndName = buildUrlAndName(
          item.brand,
          item.item_category,
          item.item_child_category
        )
        if (urlAndName === undefined) return null
        return (
          <li key={id}>
            <Chip href={urlAndName.url}>{urlAndName.name}</Chip>
          </li>
        )
      })}
    </Base>
  )
}
